import React from "react";
import { withStyles } from "@material-ui/core";
import { InputBaseComponentProps } from "@material-ui/core/InputBase";
import { Classes, ThemeType } from "@theme";
import ConsultantSelectorValue from "./ConsultantSelectorValue";
import { SelectorValueInputProps } from "../base/utils";

export type ConsultantSelectorInputProps = InputBaseComponentProps &
  SelectorValueInputProps & {
    classes?: Classes<typeof styles>;
  };

class ConsultantSelectorInput extends React.Component<ConsultantSelectorInputProps> {
  renderEmpty() {
    return (
      <div className={this.props.classes.root} onClick={this.props.onClick as any}>
        &nbsp;
      </div>
    );
  }

  renderValue() {
    return (
      <ConsultantSelectorValue
        clearable={this.props.clearable}
        disabled={this.props.disabled}
        onClear={this.props.onClear}
        value={this.props.value}
      />
    );
  }

  render() {
    return this.props.value.length > 0 ? this.renderValue() : this.renderEmpty();
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    padding: "6px 0 5px",
    width: "100%"
  }
});

export default withStyles(styles)(ConsultantSelectorInput);
